// Small visual chip that distinguishes Test (default) from Real stocks.
// Test = yellow-ish neutral tone; Real = green accent.
export default function StatusBadge({ status = "test", size = "sm" }) {
  const isReal = String(status).toLowerCase() === "real";
  const sz = size === "xs"
    ? "text-[9px] px-1.5 py-0.5"
    : "text-[10px] px-2 py-0.5";
  const cls = isReal
    ? "text-[#00E676] bg-[#00E676]/10 border-[#00E676]/25"
    : "text-[#FFCC00] bg-[#FFCC00]/10 border-[#FFCC00]/25";
  return (
    <span
      className={`inline-flex items-center rounded-full border ${cls} ${sz} font-mono-num uppercase tracking-widest`}
      data-testid={`status-badge-${isReal ? "real" : "test"}`}
    >
      {isReal ? "Réel" : "Test"}
    </span>
  );
}
